import React, { useEffect, useState } from 'react';
import styles from '../../assets/styles/Catalogue/Catalogue.module.scss';
import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	MimaToastUtil,
} from '../../components';
import { ordersStore } from '../../stores';
import { Formik } from 'formik';
import { amountFormatter } from '../../utils/utils';
import constant from '../../utils/constant';
import { BookingController } from '../../controllers';
import { useNavigate } from 'react-router-dom';
import { AddRequestContainer } from '../../containers';
import { AnimatePresence } from 'framer-motion';
import moment from 'moment';

const ViewMoreDesign = ({
	designList,
	loading,
	amount,
	setAmount,
	selectedImage,
	handleClick,
	goToRequestModal,
	closeModal,
	requestModal,
}) => {
	const [withMaterial, setWithMaterial] = useState(true);
	const [quantity, setQuantity] = useState(1);
	const design = designList.cell.row.original;

	const currentDate = moment();

	const fromDate = currentDate.add(
		design.daysRequiredForDelivery.early,
		'days'
	);
	const toDate = currentDate.add(design.daysRequiredForDelivery.late, 'days');

	const formattedFromDate = fromDate.format('MMMM D, YYYY');
	const formattedToDate = toDate.format('MMMM D, YYYY');

	return (
		<div className={styles.container}>
			<div className={styles.container_heading}>
				<div className={styles.container_heading__shape}>
					{' '}
					{design.business?.tradingName?.charAt(0).toUpperCase()}
				</div>
				<MimaText variant="subtitleBold" color="var(--color-white)">
					{design.business.tradingName}
				</MimaText>
			</div>
			<div className={styles.section}>
				<div className={styles.imageContainer}>
					<div className={styles.smallImages}>
						{design.imageUrls.map((imageUrl, i) => (
							<img
								src={imageUrl}
								alt={`design ${i}`}
								key={i}
								className={`${styles.smallImage} ${selectedImage === i ? styles.selectedSmallImage : ''}`}
								id={i}
								onClick={() => handleClick(i)}
							/>
						))}
					</div>
					<div className={styles.largeImageContainer}>
						<img
							src={design.imageUrls[selectedImage]}
							alt="Design"
							className={`${styles.largeImage} ${selectedImage !== null ? styles.selectedLargeImage : ''}`}
						/>
					</div>
				</div>
				<div className={styles.section_form}>
					<Formik
						initialValues={{
							amount: '',
							quantity: 1,
						}}>
						{({
							handleChange,
							handleBlur,
							setFieldValue,
							handleSubmit,
							values,
							errors,
							touched,
						}) => (
							<div>
								<MimaText variant="subtitleBold" align="center" width="100%">
									{design.name}
								</MimaText>
								<MimaText variant="subtitle" align="center" width="100%" mt={2}>
									{design.description}
								</MimaText>

								<hr className={styles.line} />
								<div className={styles.btn}>
									<div>
										<MimaText variant="small">Price with Material</MimaText>
										<MimaButton
											variant="outlined3"
											title={amountFormatter('NGN').format(
												design.sellingPrice.withMaterial
											)}
											width={18}
											onClick={() => {
												setFieldValue(
													'amount',
													design.sellingPrice.withMaterial
												);
												setWithMaterial(true);
											}}
										/>
									</div>

									<div>
										<MimaText variant="small">Price without Material</MimaText>
										<MimaButton
											variant="outlined3"
											title={amountFormatter('NGN').format(
												design.sellingPrice.withoutMaterial
											)}
											width={18}
											onClick={() => {
												setFieldValue(
													'amount',
													design.sellingPrice.withoutMaterial
												);
												setWithMaterial(false);
											}}
										/>
									</div>
								</div>
								<div className={styles.dtl}>
									<MimaInput
										type="number"
										variant="filterForm"
										labelTitle="Quantity"
										placeholder="Select quantity"
										id="quantity"
										value={values.quantity}
										onChange={handleChange}
										onBlur={handleBlur}
										error={errors.quantity}
										touched={touched.quantity}
										width={18}
										mb={2}
									/>
									<MimaInput
										variant="filterForm"
										labelTitle="Amount"
										id="amount"
										value={amountFormatter(
											design.sellingPrice.currencyCode
										).format(values.amount * values.quantity)}
										onChange={handleChange}
										onBlur={handleBlur}
										error={errors.amount}
										touched={touched.amount}
										width={18}
										mb={2}
										disabled={true}
									/>
								</div>
								{design.daysRequiredForDelivery.early !== 0 ||
									(design.daysRequiredForDelivery.late !== 0 && (
										<>
											<MimaText variant="smallBold" mt={2}>
												Delivery Timeline
											</MimaText>
											<div className={styles.dtl}>
												<MimaText labelTitle="From">
													{formattedFromDate}
												</MimaText>
												<MimaText labelTitle="To">{formattedToDate}</MimaText>
											</div>
										</>
									))}

								{design.business.plan === 'Basic Lite' ? (
									<>
										<MimaButton
											title="Request Design"
											onClick={() => {
												goToRequestModal();
												setQuantity(values.quantity);
											}}
											type="submit"
											loading={loading}
											variant="form"
										/>
									</>
								) : (
									<>
										<MimaButton
											title="Make Payment"
											onClick={handleSubmit}
											type="submit"
											loading={loading}
											variant="form"
											mb={2}
										/>
										<MimaButton
											title="Book consultation"
											onClick={handleSubmit}
											type="submit"
											loading={loading}
											variant="form"
											buttonColor="var(--color-dark)"
										/>
									</>
								)}
							</div>
						)}
					</Formik>
				</div>
			</div>
			{requestModal && (
				<div className="modal">
					<AnimatePresence>
						{requestModal && (
							<AddRequestContainer
								closeModal={closeModal}
								design={design}
								withMaterial={withMaterial}
								quantity={quantity}
							/>
						)}
					</AnimatePresence>
				</div>
			)}
		</div>
	);
};

export default ViewMoreDesign;
